import { render, staticRenderFns } from "./PersonDetail.vue?vue&type=template&id=73a97d84&scoped=true&"
import script from "./PersonDetail.vue?vue&type=script&lang=js&"
export * from "./PersonDetail.vue?vue&type=script&lang=js&"
import style0 from "./PersonDetail.vue?vue&type=style&index=0&id=73a97d84&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a97d84",
  null
  
)

export default component.exports